<template>
  <div
	  class="repeatable"
	  :class="{
        striped: striped,
        stacked: stacked
      }"
  >
      <div
      v-for="(row, index) in localValue"
      :key="index"
      class="repeatable-row"
      :class="{
        flex: !stacked
      }"
    >
      <div
        class="repeatable-row-content"
        :class="{
          flex: !stacked
        }"
      >
        <slot :row="row" :rowIndex="index"></slot>
      </div>
      <div
        class="repeatable-row-controls"
        :class="{
          'in-striped': striped,
          'in-stacked': stacked
        }"
      >
        <span v-if="!addIconToBtm" class="repeatable-row-control" @click="addRow(index)">
          <i :class="`fa ${faAddIcon} fa-fw`"></i>
        </span>
        <span class="repeatable-row-control" @click="removeRow(index)">
          <i :class="`fa ${faRemoveIcon} fa-fw`"></i>
        </span>
      </div>
    </div>

    <div v-if="addIconToBtm" class="text-right">
      <button class="btn-sm btn-primary" @click.prevent="addRow()"><i :class="`fa ${faAddIcon} fa-fw`"></i> Add</button>
    </div>
  </div>
</template>
<script>
  import { cloneDeep } from 'lodash'

  export default{
    data(){
      return {
        localValue: this.value && this.value.length ? this.value : cloneDeep(this.proto),
        faRemoveIcon : this.removeIcon,
        faAddIcon : this.addIcon,
        emit: true
      }
    },
    props:{
      value: {
        default(){ return [] }
      },
      proto: {type: Array, required: true},
      striped: { type: Boolean, default: false },
      stacked: { type: Boolean, default: false },
      addIconToBtm: { type: Boolean, default: false },
      addIcon: { type: String, default: 'fa-plus' },
      removeIcon: { type: String, default: 'fa-trash' },
    },
    methods:{
      addRow(index = false){
        let newRow = {};
        const value = this.localValue
        let keys = Object.keys(value[0])

        keys.forEach( key => newRow[key]=this.proto[0][key] )
        index !== false ? value.splice(index + 1, 0, newRow) : value.push(newRow)
        this.localValue = value
      },
      removeRow(index){
        const value = this.localValue

        value.splice(index, 1)
        this.localValue = value.length ? value : cloneDeep(this.proto)
      }
    },
    watch:{
      localValue:{
        handler(val) {
          if (!this.emit) return

          if ( JSON.stringify(this.localValue) !== JSON.stringify(this.proto) ){
			  this.$dispatch('input', this.localValue)
          }
        },
        deep: true
      },
      value:{
        handler() {
          this.emit = false
          this.localValue = this.value.length ? this.value : cloneDeep(this.proto)
          setTimeout(() => { this.emit = true; }, 100)
        },
        deep: true
      }
    },
  }
</script>
<style scoped lang="scss">
  .repeatable-row-controls {
    display: flex;
    .repeatable-row-control > button {
      display: flex;
      align-items: center;
      outline: none;
    }
  }
  .repeatable-row-controls.in-stacked {
    text-align: center;
    position: relative;
    .repeatable-row-control{
      position:relative;
      z-index: 2;
    }
    &::after {
      content: "";
      width: 100%;
      height: 1px;
      background: #eee;
      position: absolute;
      transform: translateX(-50%);
      left: 50%;
      top: -5px;
    }
    &::before{
      content:"";
      position:absolute;
      top:-5px;
      left:50%;
      transform:translateX(-50%);
      width: 0;
      height: 0;
      border-left: 80px solid transparent;
      border-right: 80px solid transparent;
      border-top: 50px solid #eee;
    }
  }

  .repeatable-row{
    margin-bottom:10px;
    align-items: center;
    &.flex{
      display:flex;
    }
  }
  .repeatable-row-control{
    cursor:pointer;
    margin-right:10px;
  }
  .striped{
    .repeatable-row:nth-of-type(even){
      background:#eee;
    }
  }
</style>
<style lang="scss">
  .repeatable-row-content {
    width: 100%;

    &.flex {
      display:flex;
    }

    & > * {
      margin-right:10px;
    }

    & > div {
      width:100%;
    }
  }

</style>
